import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';

const FloatingWhatsApp = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const timer1 = setTimeout(() => setShowTooltip(true), 3000);
    const timer2 = setTimeout(() => setShowTooltip(false), 10000);
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  const phoneNumber = "6282315268197";
  const message = encodeURIComponent("Halo Tanjung Priok Logistik, saya ingin bertanya seputar layanan pengiriman.");
  const waUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <div className="fixed bottom-24 md:bottom-8 right-6 z-50 flex flex-col items-end">
      
      <AnimatePresence>
        {showTooltip && (
          <motion.div
            initial={{ opacity: 0, y: 10, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.9 }}
            className="mb-4 bg-white px-4 py-3 rounded-2xl shadow-xl shadow-black/10 border border-gray-100 flex items-start gap-3 max-w-[250px]"
          >
            <div>
              <p className="text-sm font-semibold text-gray-800 mb-1">Halo! 👋</p>
              <p className="text-xs text-gray-600">Ada yang bisa kami bantu seputar pengiriman Anda hari ini?</p>
            </div>
            <button 
              onClick={() => setShowTooltip(false)}
              className="text-gray-400 hover:text-gray-600 mt-0.5"
            >
              <FiX size={14} />
            </button>
            {/* Chat Bubble Tail */}
            <div className="absolute -bottom-2 right-6 w-4 h-4 bg-white border-b border-r border-gray-100 transform rotate-45"></div>
          </motion.div>
        )}
      </AnimatePresence>

      <a
        href={waUrl}
        target="_blank"
        rel="noreferrer"
        className="relative flex items-center justify-center w-14 h-14 bg-[#25D366] hover:bg-[#20bd5a] text-white rounded-full shadow-lg transition-transform hover:scale-110 group"
      >
        <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30"></div>
        <FaWhatsapp size={32} className="text-white z-10" />
      </a>
    </div>
  );
};

export default FloatingWhatsApp;